import React from "react";
import { useTranslation } from "react-i18next";
import "./MobileNav.scss";
import "./Header.scss";
import { Link } from "react-router-dom";

const MobileNav = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mobile__nav__links">
        <Link to="/">{t("home")}</Link>
        <div className="dropdown">
          <Link to="#" className="dropdown-toggle">
            {t("hkas")}
          </Link>
          <div className="dropdown-content__mobile">
            <Link to="/about">{t("about_hong_kong_arbitration_society")}</Link>
            <Link to="/welcomemessage">{t("welcome_message")}</Link>
            <Link to="/constitution">{t("constitution")}</Link>
            <Link to="/contactus" href="#"> {t("contact_us")}</Link>
            {/* <Link to="/joinus" href="#"> {t("join_us")}</Link> */}
          </div>
        </div>
        <div className="dropdown">
          <Link to="#" className="dropdown-toggle">
            {t("arbitration")}
          </Link>
          <div className="dropdown-content__mobile">
            <Link to="/whatisarbitration" href="#">
              {t("what_is_arbitration")}
            </Link>
            <Link to="/efficientarbitration" href="#">
              {t("what_is_efficient_arbitration")}
            </Link>
            <Link to="/whyhkasrules" href="#">
              {t("why_hkas_rules?")}
            </Link>
            <Link to="/arbitrationclauses" href="#">
              {t("arbitration_clauses")}
            </Link>
            <Link to="/arbitrationagreement" href="#">
              {t("arbitration_agreement")}
            </Link>
            <Link to="/arbitrationsocietyrules" href="#">
              {t("hong_kong_arbitration_society_rules")}
            </Link>
            <Link to="/arbitrationprocess" href="#">
              {t("process_page_header2")}
            </Link>
            <Link to="/hearingtimetable" href="#">
              {t("hearing_timetable")}
            </Link>
            <Link to="/arbitrationfees" href="#">
              {t("fees")}
            </Link>
            <Link to="/enforcement" href="#">
              {t("enforcement")}
            </Link>
            <Link to="/arbitrationq&a" href="#">
              {t("q&a")}
            </Link>
          </div>
        </div>
        <div className="dropdown">
          <Link className="dropdown-toggle" to="#">
            {t("mediation")}
          </Link>
          <div className="dropdown-content__mobile">
            <Link to="/whatismediation" href="#">
              {t("what_is_mediation")}
            </Link>
            <Link to="/whymediation" href="#">
              {t("why_mediation")}
            </Link>
            <Link to="/mediationprocess" href="#">
              {t("process")}
            </Link>
            <Link to="/whoneedsmediationservice" href="#">
              {t("who_needs_mediation_service")}
            </Link>
            <Link to="/mediationfees" href="#">
              {t("fees")}
            </Link>
            <Link to="/hkasmediationrules" href="#">
              {t("hong_kong_arbitration_society_mediation_rules")}
            </Link>
            <Link to="/mpmhk" href="#">
              {t("mediation_practice_manual_for_hong_kong")}
            </Link>
            <Link to="/q&a" href="#">
              {t("q&a")}
            </Link>
          </div>
        </div>

        <div className="dropdown">
          <Link className="dropdown-toggle" to="#">
            {t("hk_renovation_guideline")}
          </Link>
          <div className="dropdown-content__mobile">

            <Link to="/decoration" href="#">
              {t("decoration")}
            </Link>
            <Link to="/hkrenovationguideline" href="#">
              {t("hk_renovation_guideline")}
            </Link>
          </div>
        </div>
        
        {/* <Link to="/hkrenovationguideline">{t("hk_renovation_guideline")}</Link> */}
        <div className="dropdown">
          <Link className="dropdown-toggle" to="#">
            {t("harmony_hk")}
          </Link>
          <div className="dropdown-content__mobile">
            <Link to="/aboutcharter" href="#">
              {t("about_the_charter")}
            </Link>
            <Link to="/recognitionceremonyreview" href="#">
              {t("recognition_ceremony_review")}
            </Link>
            <Link to="/signthecharter" href="#">
              {t("sign_the_charter")}
            </Link>
            <Link to="/listofparticipatinginstitutions" href="#">
              {t("list_of_participating_institutions")}
            </Link>
          </div>
        </div>
        <div className="dropdown">
          <Link className="dropdown-toggle" to="#">
            {t("society_information")}
          </Link>
          <div className="dropdown-content__mobile">
            <Link to="/radioprogram" href="#">
              {t("radio_program")}
            </Link>
            <Link to="/societynews" href="#">
              {t("blog")}
            </Link>
            <Link to="/decoration" href="#">
              {t("decoration")}
            </Link>
            <Link to="/sharelaw" href="#">
              {t("share_law")}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNav;
